// extracted by mini-css-extract-plugin
module.exports = {"register__message":"register__message__XfDRi"};